<template>
    <section id="about">
    <div id="about-text">
      <p class="section-subtitle" style="color: #fff">Sobre nós</p>
      <h3 class="section-title" style="color: #fff">
        Uma escola que tem o foco no aluno, <br />
        ensinando com metodologias personalizadas para atingir os melhores
        resultados.
      </h3>
      <div class="about-description">
        <!-- <i class="bi bi-music-note"></i> -->
        <div>
          <h4>Professores renomados</h4>
          <p>
            Professores especializados em educação, música e mercado de
            trabalho.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
    name:'SobreNos'
}
</script>
